import styled from '@emotion/styled';

import { Breakpoints } from 'utils/const.styles';

export const HeaderWrapper = styled.div`
	width: 100%;
	display: flex;
	flex-direction: row;
	align-items: center;
	justify-content: space-between;
	padding: 1rem 0;
	position: relative;
	padding-bottom: 2.6rem;
	gap: 1rem;

	@media ${Breakpoints.tablet} {
		height: unset;
		margin: unset;
		align-items: unset;
		padding: 2rem 1rem;

		:has(.wizardMobile) {
			flex-direction: column;
		}
	}

	.progressWizard:has(.wizardMobile) {
		padding: 0;
	}

	@media ${Breakpoints.mobile} {
		.button > .button-text {
			display: none;
		}
	}
`;

export const PageHeaderContent = styled.div`
	flex: 1;
`;
export const PageHeaderActions = styled.div`
	display: flex;
	justify-content: flex-end;
	flex: 1;
`;

export const HeaderRowContent = styled.div`
	display: flex;
	flex-direction: row;
	align-items: center;
	flex-wrap: nowrap;
	width: 100%;
	height: 100%;
	flex: 1;
	gap: 1rem;

	.module-tooltip {
		border: 1px solid var(--blue);
		padding: 0.4rem;
		border-radius: var(--small-border-radius);

		> svg {
			height: 1.25em;
		}
	}

	body[dir='rtl'] & {
		.icon {
			transform: scaleX(-1);
		}
	}
`;

export const HeaderColumnContent = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: center;
	height: 100%;
	gap: 0.25rem;
`;
